import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Modal from "react-modal";
import Pagination from "../../../components/Pagination";

const SalaryTemplateView = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [docurl, setDocUrl] = useState(false);

  const [AttendanceId, setAttendanceId] = useState(null);

  //

  const { sendRequest: getAttendance } = useHttp();

  const getAllData = () => {
    getAttendance(
      {
        url: `/api/salaryTemplate/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
   // //console.log(data);

    const salaryTemplateId = data && data.salaryTemplateId;

    getAttendance(
      {
        url: `/api/salaryTemplate/?orgId=${localStorage.getItem(
          "orgId"
        )}&salaryTemplateId=${salaryTemplateId}`,
      },
      (res) => {
      //  //console.log(res);
        setSelectedData(res);
      }
    );

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const Shift = (option) => {
    switch (option) {
      case 1:
        return "First Shift";
      case 2:
        return "Second Shift";
      case 3:
        return "Third Shift";
    }
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Salary Template</label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Template
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-sm">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Effective From</th>
                          <th>Employee</th>
                          <th>Warehouse</th>
                          <th>Gross Salary</th>
                          <th>Payout Salary</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.salaryTemplateDate}</td>
                                <td>{itm.effectiveFrom}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.warehouseName}</td>

                                <td>{itm.grossSalary}</td>
                                <td>{itm.inhandSalary}</td>
                                <td>
                                  {/* <button
                                    onClick={() => {
                                      props.addForm(true);
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i> 
                                  </button> */}
                                  <button
                                    onClick={() => openModal(itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-eye"></i> 
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                    <br />
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="">
            <h4 className="card-title">Employee Attendance Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div className="row">
              <p className="col-md-6">
                <b>Employee :</b> {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                <b> WareHouse Name :</b> {selectedData.warehouseName}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                <b>Date :</b> {selectedData.salaryTemplateDate}
              </p>
              <p className="col-md-6">
                <b> Effective From Date :</b> {selectedData.effectiveFrom}
              </p>
            </div>

            <table className="table table-bordered table-sm">
              <thead>
                <tr className="">
                  <th>Gross Salary</th>

                  {selectedData.salaryTemplateDetails.map((headItem, index) => (
                    <React.Fragment key={index}>
                      <th>{headItem.salaryHeadName}</th>
                    </React.Fragment>
                  ))}

                  <th>Total Payout</th>
                </tr>
              </thead>
              <tbody>
                <tr className="cursor-pointer">
                  <td>{selectedData.grossSalary}</td>
                  {selectedData.salaryTemplateDetails.map((headItem, index) => (
                    <React.Fragment key={index}>
                      <td>{headItem.salaryHeadAmount}</td>
                    </React.Fragment>
                  ))}{" "}
                  <td>{selectedData.inhandSalary}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default SalaryTemplateView;
